<template>
    <div>
        <div class="imposto-div-retencao">
            <b-row>
                <b-col sm="2">
                    <CheckboxSimple title="Reter ISS" :disabled="disabled" v-model="imposto.issRetido" />
                </b-col>
                <b-col sm="2" v-if="!ehSimplesNacional">
                    <CheckboxSimple title="Reter PIS/COFINS" :disabled="disabled" v-model="imposto.pisCofinsRetido" />
                </b-col>
            </b-row>
        </div>
        <b-row v-if="imposto.issRetido">
            <b-col sm="2">
                <SelectStatic title="UF" :markFormDirty="true" :disabled="disabled" :required="false"
                    :initialValue="selectedUF" :data="ufs" v-model="selectedUF" />
            </b-col>
            <b-col sm="5">
                <SelectStatic title="Cidade de Incidência" :markFormDirty="true" :disabled="disabled" :required="false"
                    :initialValue="dados.descricaoCidadeIncidencia" :data="municipios"
                    v-model="dados.descricaoCidadeIncidencia" />
            </b-col>
            <b-col sm="2">
                <InputText title="Código Cidade" field="codigoCidadeIncidencia" :disabled="true" :required="false"
                    v-model="dados.codigoCidadeIncidencia" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="2">
                <InputNumber title="Alíquota ISS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.issAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota PIS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.pisAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota COFINS %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled" v-model="imposto.cofinsAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota CSLL %" field="aliquota" type="float" :formName="formName"
                    :required="false" :maxLength="9" :disabled="disabled" v-model="imposto.csllAliquota" />
            </b-col>
            <b-col sm="2" v-if="!ehSimplesNacional">
                <InputNumber title="Alíquota IR %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.irAliquota" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="2">
                <InputNumber title="Alíquota IBS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.ibsAliquota" />
            </b-col>
            <b-col sm="2">
                <InputNumber title="Alíquota CBS %" field="aliquota" type="float" :formName="formName" :required="false"
                    :maxLength="9" :disabled="disabled" v-model="imposto.cbsAliquota" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";

import axios from "axios";
import { mapActions } from "vuex";

import NfsePrefeitura from "./NfsePrefeitura.js";

export default {
    name: "Impostos",
    props: ["formName", "ehSimplesNacional", "disabled", "value", "dados"],
    components: {
        CheckboxSimple,
        InputNumber,
        InputText,
        SelectStatic,
    },
    data() {
        return {
            id: this.$route.params.id,
            imposto: new NfsePrefeitura().imposto,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            loading: false,
            ufs: [
                { id: 'AC', content: 'AC' },
                { id: 'AL', content: 'AL' },
                { id: 'AM', content: 'AM' },
                { id: 'AP', content: 'AP' },
                { id: 'BA', content: 'BA' },
                { id: 'CE', content: 'CE' },
                { id: 'DF', content: 'DF' },
                { id: 'ES', content: 'ES' },
                { id: 'GO', content: 'GO' },
                { id: 'MA', content: 'MA' },
                { id: 'MG', content: 'MG' },
                { id: 'MS', content: 'MS' },
                { id: 'MT', content: 'MT' },
                { id: 'PA', content: 'PA' },
                { id: 'PB', content: 'PB' },
                { id: 'PE', content: 'PE' },
                { id: 'PI', content: 'PI' },
                { id: 'PR', content: 'PR' },
                { id: 'RJ', content: 'RJ' },
                { id: 'RN', content: 'RN' },
                { id: 'RO', content: 'RO' },
                { id: 'RR', content: 'RR' },
                { id: 'RS', content: 'RS' },
                { id: 'SC', content: 'SC' },
                { id: 'SE', content: 'SE' },
                { id: 'SP', content: 'SP' },
                { id: 'TO', content: 'TO' }
            ],
            municipios: [],
            selectedUF: { id: "", content: "" },
        }
    },
    mounted() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };
            this.getApi(params).then((response) => {
                if (response && response.success) {
                    const data = response.content || {};

                    const simples = data.simplesNacional === true
                        || data.simplesNacional === "Sim"
                        || data.simplesNacional === 1
                        || data.simplesNacional === "1";

                    this.ehSimplesNacional = !!simples;

                    this.imposto.issAliquota = data.iss || 0;
                    this.imposto.ibsAliquota = data.ibs || 0;
                    this.imposto.cbsAliquota = data.cbs || 0;

                    if (!this.ehSimplesNacional) {
                        this.imposto.pisAliquota = data.pis || 0;
                        this.imposto.cofinsAliquota = data.cofins || 0;
                        this.imposto.csllAliquota = data.csll || 0;
                        this.imposto.irAliquota = data.ir || 0;
                    } else {
                        this.imposto.pisAliquota = 0;
                        this.imposto.cofinsAliquota = 0;
                        this.imposto.csllAliquota = 0;
                        this.imposto.irAliquota = 0;
                    }
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        async getMunicipios() {
            if (!this.selectedUF || !this.selectedUF.id) {
                this.municipios = [];
                return;
            }

            const response = await axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.selectedUF.id}/municipios`);
            this.municipios = response.data.map(municipio => ({
                id: municipio.id.toString(),
                content: municipio.nome,
            }));
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(value) {
                if (!value) return;
                if (value === this.imposto) return;
                this.imposto = {
                    ...this.imposto,
                    ...value,
                };
            }
        },
        selectedUF: {
            deep: true,
            handler() {
                this.getMunicipios();
            }
        },
        'dados.descricaoCidadeIncidencia': {
            deep: true,
            handler(value) {
                this.dados.codigoCidadeIncidencia = value?.id ? value.id.toString() : "";
            }
        },
        imposto: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    },
}
</script>
<style scoped>
.imposto-div-retencao {
    margin-bottom: 10px;
}
</style>
